'use client'
import React from 'react'
import { X } from 'lucide-react'
import { Callout, CalloutText, Button, buttonIconVariants } from 'design-system'
import { useBannerCallout } from './banner-callout-context'
import { motion, AnimatePresence } from 'motion/react'

export const BannerCallout = () => {
  const { state, dismissBannerCallout } = useBannerCallout()
  const { calloutType, calloutSize, message, open } = state

  return (
    <AnimatePresence>
      {open ? (
        <motion.div
          className="fixed left-0 right-0 top-[var(--contract-banner-height,0px)] z-50 px-4 py-2"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -50 }}
          transition={{ duration: 0.3 }}>
          <Callout
            calloutType={calloutType}
            calloutSize={calloutSize}
            className="relative mx-auto flex max-w-5xl items-center justify-between gap-4">
            <CalloutText
              calloutSize={calloutSize}
              className="min-w-0 flex-1 break-words">
              {message}
            </CalloutText>
            <Button
              onClick={dismissBannerCallout}
              buttonType="transparent"
              className="flex-shrink-0"
              aria-label="Dismiss banner"
              leftIconSlot={
                <X
                  className={buttonIconVariants({ buttonSize: 'xs' })}
                  aria-hidden
                />
              }>
              Dismiss
            </Button>
          </Callout>
        </motion.div>
      ) : null}
    </AnimatePresence>
  )
}
